<!-- Menu.svelte -->
<script>
 import { Menu, Burger } from "@svelteuidev/core";
  import ItemMenu from "./ItemMenu.svelte";
  import { ItemMenus } from "../Classes/ItemMenus.js";
    import Constantes from "../Classes/Constantes";
    import { onMount } from "svelte";
   let element;
  let opened;
  let menuElement;
  export let menuOpen = false;
  // Listas de nomes e ícones dos itens de menu
  let itens = [
    new ItemMenus({
      nome: "Campeonatos",
      navegarPara: "/campeonatos",
      icone: "fas fa-trophy",
      permissao: "",
      SoLogado: false,
    }),
    new ItemMenus({
      nome: "Minhas inscricoes",
      navegarPara: "/minhasinscricoes",
      icone: "fas fa-user",
      permissao: "pode_ver_minhas_incricoes",
      SoLogado: true,
    })
    ,
    new ItemMenus({
      nome: "Relatórios",
      navegarPara: "/relatorios", 
      icone: "fas fa-chart-bar",
      permissao: "pode_ver_relatorio",
      SoLogado: true,
    }),
    
      new ItemMenus({
      nome: "Meu cadastro",
      navegarPara: Constantes.tela_meu_cadastro, 
      icone: "fas fa-user-circle",
      permissao: Constantes.pode_ver_meu_cadastro,
      SoLogado: true,
    }),
     new ItemMenus({
      nome: "Configurações",
      navegarPara: Constantes.tela_menu_config, 
      icone: "fa fa-cog",
      permissao: Constantes.pode_ver_configuracoes,
      SoLogado: true,
    }),
  new ItemMenus({
      nome: "Rais e baterias",
      navegarPara: Constantes.tela_bateria_raia, 
      icone: "fas fa-stopwatch",
      permissao: Constantes.pode_visualizar_raias_baterias,
      SoLogado: true,
    }),
    
     new ItemMenus({
      nome: "Ranking por prova",
      navegarPara: Constantes.tela_ranking_detalhado,
      icone: "fas fa-list-ol",
      permissao: Constantes.pode_ver_ranking_detalhado,
      SoLogado: false,
 }),  
 new ItemMenus({
      nome: "Ranking Final",
      navegarPara: Constantes.tela_ranking_geral,
      icone: "fas fa-star",
      permissao: Constantes.pode_ver_ranking_final,
      SoLogado: false,
 }),  
  new ItemMenus({
      nome: "Registrar ingressos",
      navegarPara: Constantes.tela_registra_ingressos+"?id=11",
      icone: "fas fa-ticket-alt",
      permissao: Constantes.pode_registrar_ingressos,
      SoLogado: false,
 }),  
    new ItemMenus({
      nome: "Sobre",
      navegarPara: "/sobre", 
      icone: "fas fa-info-circle",
      permissao: "",
      SoLogado: false,
    }),
    new ItemMenus({
      nome: "Logout",
      navegarPara: "/",
      icone: "fas fa-lock",
      permissao: "",
      SoLogado: true,
      logout: true  
    }),
     new ItemMenus({
      nome: "Login",
      navegarPara: "/login2",
      icone: "fas fa-lock",
      permissao: "",
      
      login: true  
    })      
  ];

 // Função para detectar clique fora do menu
  function handleClickOutside(event) {
    if (menuOpen && menuElement && !menuElement.contains(event.target)) {
      menuOpen = false;
    }
  }

  // Adicionar o evento de clique fora ao montar o componente
  onMount(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });
</script>
<div bind:this={menuElement}>
<Menu >
  <Burger
    slot="control"
    opened={menuOpen}
    on:click={() => {
      menuOpen = !menuOpen;
    }}
    color="#3f3f3f"
  />
  {#each itens as item, i}
    <ItemMenu {item} on:close={() => (menuOpen = false)} />
  {/each}
</Menu>
</div>
<style>   
  /* Estilo do menu modal */
  .menu-modal {
    position: fixed;
    top: 56px; /* Altura do navbar */
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Fundo escuro semi-transparente */
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 1000; /* Garante que o menu está sobreposto a outros elementos */
    pointer-events: none; /* Permite clicar nos elementos abaixo do menu */
  }

  .menu-content {
    width: 100%; /* Ocupa toda a largura */
    max-width: 100%; /* Largura máxima do menu */
    background-color: white;
    border-bottom-left-radius: 20px; /* Cantos inferiores arredondados */
    border-bottom-right-radius: 20px; /* Cantos inferiores arredondados */
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5); /* Sombra */
    pointer-events: auto; /* Permite clicar dentro do menu */
  }

  /* Efeito de transição para suavizar a abertura e fechamento do menu */
  .menu-modal {
    transition: opacity 0.3s ease;
  }

  /* Ajuste de visibilidade do menu */
  .menu-modal.closed {
    opacity: 0;
    pointer-events: none; /* Impede cliques no menu fechado */
  }

  /* Estilize seus itens de menu conforme necessário */
  .menu-content ul {
    list-style-type: none;
    padding: 0;
  }

  .menu-content ul li {
    margin-bottom: 10px;
  }

  .menu-content ul li a {
    color: #333;
    text-decoration: none;
  }
</style>
